/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Submissions } from '../../models/submissions';

export interface DeleteSubmissionApiV2SubmissionsOrgIdDelete$Params {
  id: string;
  org: string;
}

export function deleteSubmissionApiV2SubmissionsOrgIdDelete(http: HttpClient, rootUrl: string, params: DeleteSubmissionApiV2SubmissionsOrgIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Submissions>> {
  const rb = new RequestBuilder(rootUrl, deleteSubmissionApiV2SubmissionsOrgIdDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Submissions>;
    })
  );
}

deleteSubmissionApiV2SubmissionsOrgIdDelete.PATH = '/api/v2/submissions/{org}/{id}';
